// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import httpClient from "../../utils/httpClients";
// import { usePlayer } from "../../../PlayerContext";

// function PodcastEpisode() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [episodes, setEpisodes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [podcastInfo, setPodcastInfo] = useState(null);
//   const playTimerRef = useRef(null);
//   const videoRef = useRef(null);

//   const [playCountTracked, setPlayCountTracked] = useState({});
//   const [sharePopup, setSharePopup] = useState({ open: false, song: null });
//   const [playlistModal, setPlaylistModal] = useState({ open: false, song: null });
//   const [playlists, setPlaylists] = useState([]);
//   const [newPlaylist, setNewPlaylist] = useState({ name: "", description: "", coverImage: null });
//   const [showCreateForm, setShowCreateForm] = useState(false);
//   const [playlistLoading, setPlaylistLoading] = useState(false);
//   const [selectedPlaylists, setSelectedPlaylists] = useState(new Set());

//   const {
//     isPlaying,
//     currentTrack,
//     togglePlayPause,
//     seek,
//     duration,
//     triggerQueueUpdate,
//     playTrackById,
//     playVideoById,
//     videoRef: playerVideoRef,
//   } = usePlayer();

//   const displayTrack = currentTrack || (episodes.length > 0 ? episodes[0] : null);

//   // === UTILS ===
//   const formatDuration = useCallback((seconds) => {
//     if (!seconds || isNaN(seconds)) return "0:00";
//     const mins = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${mins}:${secs.toString().padStart(2, "0")}`;
//   }, []);

//   const generateShareableUrl = (episodeId) =>
//     `https://webmobrildemo.com/volumetv/podcast-episode/${id}/episode/${episodeId}`;

//   // === FETCH DATA ===
//   const fetchPodcastEpisodes = useCallback(async () => {
//     try {
//       setLoading(true);
//       const res = await httpClient.get(
//         `user/podcast/podcast-episodes/${id}?pageSize=50&pageNumber=1`
//       );
//       if (res.data?.success) {
//         const data = res.data.data.popularData || [];
//         const formatted = data.map((ep) => ({
//           ...ep,
//           isVideo:
//             ep.fileType === "video" ||
//             ep.mimeType?.includes("video") ||
//             ep.fileUrl?.includes(".mp4"),
//         }));
//         setEpisodes(formatted);
//         setPodcastInfo(data[0]?.parentId || {});
//       }
//     } catch (err) {
//       setError("Failed to load podcast");
//     } finally {
//       setLoading(false);
//     }
//   }, [id]);

//   // === PLAY COUNT - Only Once ===
//   const startPlayCountTimer = (contentId) => {
//     if (playCountTracked[contentId]) return;

//     if (playTimerRef.current) {
//       clearTimeout(playTimerRef.current);
//       playTimerRef.current = null;
//     }

//     playTimerRef.current = setTimeout(() => {
//       recordPlayCount(contentId);
//     }, 10000);
//   };

//   const recordPlayCount = async (contentId) => {
//     try {
//       await httpClient.post(`user/play-history/content-play-count/${contentId}`);
//       setPlayCountTracked((prev) => ({ ...prev, [contentId]: true }));
//     } catch (error) {
//       console.error("Play count error:", error);
//     }
//   };

//   // === PLAY EPISODE ===
//   const playEpisode = async (episode) => {
//     const contentId = episode._id;

//     if (currentTrack?._id === contentId) {
//       togglePlayPause();
//       return;
//     }

//     if (playTimerRef.current) {
//       clearTimeout(playTimerRef.current);
//       playTimerRef.current = null;
//     }

//     try {
//       if (episode.isVideo) {
//         await playVideoById(contentId);
//       } else {
//         await playTrackById(contentId, "audio");
//       }

//       startPlayCountTimer(contentId);
//     } catch (error) {
//       console.error("Error playing episode:", error);
//     }
//   };

//   // === LIKE/DISLIKE ===
//   const handleLikeDislike = async (contentId, currentAction) => {
//     const newAction = currentAction === "like" ? "dislike" : "like";
//     try {
//       const res = await httpClient.post(
//         `/user/play-history/like-content/${contentId}/${newAction}`
//       );
//       if (res.data?.success) {
//         setEpisodes((prev) =>
//           prev.map((ep) =>
//             ep._id === contentId
//               ? {
//                   ...ep,
//                   isLiked: newAction === "like",
//                   likesCount:
//                     newAction === "like"
//                       ? (ep.likesCount || 0) + 1
//                       : Math.max(0, (ep.likesCount || 0) - 1),
//                 }
//               : ep
//           )
//         );
//       }
//     } catch (err) {
//       console.error("Like error:", err);
//     }
//   };

//   // === QUEUE ACTION ===
//   const handleQueueAction = async (action, trackId) => {
//     try {
//       const payload = { action };
//       if (trackId) payload.trackId = trackId;
//       const res = await httpClient.post("user/queue/queue-controller", payload);
//       if (res.data?.success) triggerQueueUpdate();
//     } catch (err) {
//       console.error("Queue error:", err);
//     }
//   };

//   // === SHARE ===
//   const shareOnSocialMedia = (platform, episode) => {
//     const url = generateShareableUrl(episode._id);
//     const text = `Check out: ${episode.title}`;
//     const links = {
//       facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
//       twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
//       whatsapp: `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
//       telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
//     };
//     window.open(links[platform], "_blank", "width=600,height=400");
//   };

//   const copyLink = async () => {
//     const text = generateShareableUrl(sharePopup.song._id);
//     try {
//       await navigator.clipboard.writeText(text);
//       alert("Copied!");
//     } catch (err) {
//       const textarea = document.createElement("textarea");
//       textarea.value = text;
//       document.body.appendChild(textarea);
//       textarea.select();
//       document.execCommand("copy");
//       document.body.removeChild(textarea);
//       alert("Copied!");
//     }
//   };

//   // === PLAYLIST MODAL ===
//   const fetchPlaylists = useCallback(async () => {
//     try {
//       const res = await httpClient.get("/user/playlist/get-playlists");
//       if (res.data?.success) setPlaylists(res.data.data.playlist || []);
//     } catch (err) {
//       console.error("Error fetching playlists:", err);
//     }
//   }, []);

//   const openPlaylistModal = useCallback(
//     (episode, e) => {
//       e.preventDefault();
//       e.stopPropagation();
//       setPlaylistModal({ open: true, song: episode });
//       setSelectedPlaylists(new Set());
//       fetchPlaylists();
//       setOpenDropdown(null);
//     },
//     [fetchPlaylists]
//   );

//   const togglePlaylistSelection = (playlistId) => {
//     setSelectedPlaylists((prev) => {
//       const newSet = new Set(prev);
//       newSet.has(playlistId) ? newSet.delete(playlistId) : newSet.add(playlistId);
//       return newSet;
//     });
//   };

//   const addToSelectedPlaylists = async () => {
//     if (selectedPlaylists.size === 0) return;
//     setPlaylistLoading(true);
//     try {
//       for (const pid of selectedPlaylists) {
//         await httpClient.post(
//           `/user/playlist/add-item?playlistId=${pid}&itemId=${playlistModal.song._id}&itemType=Music`
//         );
//       }
//       setPlaylistModal({ open: false, song: null });
//     } catch (err) {
//       console.error("Error adding to playlists:", err);
//     } finally {
//       setPlaylistLoading(false);
//     }
//   };

//   const createNewPlaylist = async () => {
//     if (!newPlaylist.name.trim()) return alert("Name required");
//     setPlaylistLoading(true);
//     const formData = new FormData();
//     formData.append("name", newPlaylist.name);
//     formData.append("description", newPlaylist.description);
//     if (newPlaylist.coverImage) formData.append("coverImage", newPlaylist.coverImage);

//     try {
//       const res = await httpClient.post("/user/playlist/create-playlist", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (res.data?.success) {
//         await fetchPlaylists();
//         if (playlistModal.song) {
//           await httpClient.post(
//             `/user/playlist/add-item?playlistId=${res.data.data._id}&itemId=${playlistModal.song._id}&itemType=Music`
//           );
//         }
//         setPlaylistModal({ open: false, song: null });
//         setShowCreateForm(false);
//         setNewPlaylist({ name: "", description: "", coverImage: null });
//       }
//     } catch (err) {
//       alert("Failed to create playlist");
//     } finally {
//       setPlaylistLoading(false);
//     }
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) setNewPlaylist((prev) => ({ ...prev, coverImage: file }));
//   };

//   // === DROPDOWN TOGGLE ===
//   const toggleDropdown = (episodeId, e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     setOpenDropdown((prev) => (prev === episodeId ? null : episodeId));
//   };

//   // === SYNC VIDEO REF & SRC WITH PLAYER CONTEXT ===
//   useEffect(() => {
//     if (videoRef.current && playerVideoRef && displayTrack?.isVideo) {
//       playerVideoRef.current = videoRef.current;
//       playerVideoRef.current.src = displayTrack.fileUrl;
//       playerVideoRef.current.poster = displayTrack.coverImageUrl || "";
//       playerVideoRef.current.playsInline = true;
//     }
//   }, [playerVideoRef, displayTrack]);

//   // === LIFECYCLE ===
//   useEffect(() => {
//     if (id) fetchPodcastEpisodes();
//   }, [id, fetchPodcastEpisodes]);

//   useEffect(() => {
//     if (currentTrack) {
//       setPlayCountTracked((prev) => ({ ...prev, [currentTrack._id]: false }));
//     }
//   }, [currentTrack]);

//   useEffect(() => {
//     if (isPlaying && currentTrack) {
//       const contentId = currentTrack._id;
//       if (!playCountTracked[contentId]) {
//         startPlayCountTimer(contentId);
//       }
//     } else {
//       if (playTimerRef.current) {
//         clearTimeout(playTimerRef.current);
//         playTimerRef.current = null;
//       }
//     }

//     return () => {
//       if (playTimerRef.current) clearTimeout(playTimerRef.current);
//     };
//   }, [isPlaying, currentTrack?._id, playCountTracked]);

//   useEffect(() => {
//     const handleOutside = (e) => {
//       if (!e.target.closest(".dropdown")) setOpenDropdown(null);
//       if (!e.target.closest(".share-popup") && !e.target.closest(".single-item__export"))
//         setSharePopup({ open: false, song: null });
//       if (!e.target.closest(".playlist-popup") && !e.target.closest(".dropdown-item")) {
//         setPlaylistModal({ open: false, song: null });
//         setShowCreateForm(false);
//       }
//     };
//     document.addEventListener("mousedown", handleOutside);
//     return () => document.removeEventListener("mousedown", handleOutside);
//   }, []);

//   // === HELPERS ===
//   const isCurrentPlaying = (id) => currentTrack?._id === id;

//   // === RENDER ===
//   if (loading) {
//     return (
//       <div className="content-inner pb-0 container-fluid" id="page_layout">
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{ height: "50vh" }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="sr-only">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="content-inner pb-0 container-fluid">
//         <div className="alert alert-danger text-center">{error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       <div className="row row--grid">
//         <div className="col-12">
//           <ul className="breadcrumb">
//             <li className="breadcrumb__item">
//               <Link to="/">Home</Link>
//             </li>
//             <li className="breadcrumb__item">
//               <Link to="/podcasts">Podcasts</Link>
//             </li>
//             <li className="breadcrumb__item breadcrumb__item--active">
//               {podcastInfo?.title || "Episode"}
//             </li>
//           </ul>
//           <div className="main__title main__title--page">
//             <h1>{podcastInfo?.title || "Podcast"}</h1>
//             {displayTrack && (
//               <span className="badge bg-primary ms-2">
//                 {displayTrack.isVideo ? "Video" : "Audio"}
//               </span>
//             )}
//           </div>
//         </div>

//         <div className="col-12">
//           <div className="release">
//             <div className="release__content">
//               <div className="release__cover">
//                 {displayTrack?.isVideo ? (
//                   <div
//                     className="position-relative rounded overflow-hidden"
//                     style={{ maxHeight: "340px", background: "#000" }}
//                   >
//                     <video
//                       ref={videoRef}
//                       className="w-100 h-100"
//                       style={{ objectFit: "contain" }}
//                       src={displayTrack.fileUrl}
//                       poster={displayTrack.coverImageUrl}
//                       playsInline
//                     />
//                   </div>
//                 ) : (
//                   <div className="position-relative">
//                     <img
//                       src={displayTrack?.coverImageUrl}
//                       alt="cover"
//                       className="img-fluid rounded"
//                       style={{ maxHeight: "340px" }}
//                     />
//                     {isPlaying && currentTrack && (
//                       <div className="position-absolute top-50 start-50 translate-middle">
//                         <i
//                           className="fas fa-volume-up fa-beat text-white"
//                           style={{
//                             fontSize: "60px",
//                             filter: "drop-shadow(0 0 10px #000)",
//                           }}
//                         ></i>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>

//               <div className="release__stat">
//                 <span>{episodes.length} episodes</span>
//                 <span>
//                   {episodes
//                     .reduce((a, b) => a + (b.playCount || 0), 0)
//                     .toLocaleString()}{" "}
//                   listens
//                 </span>
//               </div>
//               <div className="d-flex justify-content-between gap-3 mt-3">
//                 <a
//                   className="release__buy open-modal"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     togglePlayPause();
//                   }}
//                   style={{ cursor: "pointer" }}
//                 >
//                   <i className={isPlaying ? "fas fa-pause" : "fas fa-play"}></i>{" "}
//                   {isPlaying ? "PAUSE" : "PLAY"}
//                 </a>
//               </div>
//             </div>

//             <div className="release__list mt-5">
//               <h4 className="card-title text-white mb-4">All Episodes</h4>
//               <ul className="main__list main__list--playlist main__list--dashbox">
//                 {episodes.length > 0 ? (
//                   episodes.map((episode, i) => {
//                     const contentId = episode._id;
//                     const isCurrent = currentTrack?._id === contentId;
//                     const playing = isCurrentPlaying(contentId);
//                     const isDropdownOpen = openDropdown === contentId;
//                     const artistId = episode.artistId || episode.artist?._id;
//                     const albumId = episode.albumId || episode.album?._id;

//                     return (
//                       <li
//                         key={contentId}
//                         className={`single-item list-1 ${isCurrent ? "active-episode" : ""}`}
//                         style={{
//                           backgroundColor: playing ? "rgba(255,255,255,0.1)" : "",
//                           borderLeft: playing ? "3px solid #1DB954" : "3px solid transparent",
//                         }}
//                       >
//                         <div
//                           className="single-item__cover"
//                           onClick={() => playEpisode(episode)}
//                           style={{ cursor: "pointer" }}
//                         >
//                           <img
//                             src={
//                               episode.coverImageUrl ||
//                               `${process.env.PUBLIC_URL}/img/covers/cover.svg`
//                             }
//                             alt={episode.title}
//                           />
//                           {playing && isPlaying ? (
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               viewBox="0 0 24 24"
//                               style={{ fill: "#1DB954" }}
//                             >
//                               <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
//                             </svg>
//                           ) : (
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               viewBox="0 0 24 24"
//                               style={{ fill: playing ? "#1DB954" : "#fff" }}
//                             >
//                               <path d="M18.54,9L8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
//                             </svg>
//                           )}
//                         </div>

//                         <div
//                           className="single-item__title"
//                           onClick={() => playEpisode(episode)}
//                           style={{ cursor: "pointer" }}
//                         >
//                           <h4>
//                             {i + 1}. {episode.title}
//                             {playing && (
//                               <span className="badge bg-success ms-2">
//                                 Playing
//                               </span>
//                             )}
//                             {episode.isVideo && (
//                               <i className="fas fa-video text-primary ms-2"></i>
//                             )}
//                           </h4>
//                           <span>{episode.artist || "Unknown Artist"}</span>
//                         </div>

//                         {/* Dropdown */}
//                         <div className="dropdown">
//                           <span
//                             className={`d-flex text-white align-items-center h5 mb-0 ${isDropdownOpen ? "show" : ""}`}
//                             onClick={(e) => toggleDropdown(contentId, e)}
//                           >
//                             <i className="fas fa-ellipsis-h"></i>
//                           </span>
//                           <div
//                             className={`dropdown-menu dropdown-menu-end ${isDropdownOpen ? "show" : ""}`}
//                             style={
//                               isDropdownOpen
//                                 ? {
//                                     position: "absolute",
//                                     inset: "0px 0px auto auto",
//                                     margin: "0px",
//                                     transform: "translate(0px, 19px)",
//                                   }
//                                 : {}
//                             }
//                           >
//                             <a
//                               className="dropdown-item"
//                               href="#!"
//                               onClick={(e) => openPlaylistModal(episode, e)}
//                             >
//                               <span className="material-icons">library_music</span> Add To Playlist
//                             </a>

//                             <a
//                               className="dropdown-item"
//                               href="#!"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 handleQueueAction("add", contentId);
//                                 setOpenDropdown(null);
//                               }}
//                             >
//                               <span className="material-icons">playlist_add</span> Add To Queue
//                             </a>

//                             <a
//                               className={`dropdown-item ${!artistId ? "disabled" : ""}`}
//                               href="#!"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 if (artistId) {
//                                   navigate(`/artist/${artistId}`);
//                                   setOpenDropdown(null);
//                                 }
//                               }}
//                             >
//                               <span className="material-icons">music_note</span> Go To Artist
//                             </a>

//                             <a
//                               className={`dropdown-item ${!albumId ? "disabled" : ""}`}
//                               href="#!"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 if (albumId) {
//                                   navigate(`/album/${albumId}`);
//                                   setOpenDropdown(null);
//                                 }
//                               }}
//                             >
//                               <span className="material-icons">album</span> Go To Album
//                             </a>
//                           </div>
//                         </div>

//                         <a
//                           href="#!"
//                           className="single-item__add"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             handleLikeDislike(
//                               contentId,
//                               episode.isLiked ? "like" : "dislike"
//                             );
//                           }}
//                         >
//                           <i
//                             className={
//                               episode.isLiked
//                                 ? "fas fa-heart text-danger"
//                                 : "far fa-heart"
//                             }
//                           ></i>
//                         </a>

//                         <a
//                           href="#!"
//                           className="single-item__export"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             setSharePopup({ open: true, song: episode });
//                           }}
//                         >
//                           <i className="fas fa-share"></i>
//                         </a>

//                         <span className="single-item__time">
//                           {isCurrent
//                             ? `${formatDuration(seek)} / ${formatDuration(duration)}`
//                             : formatDuration(episode.duration)}
//                         </span>
//                       </li>
//                     );
//                   })
//                 ) : (
//                   <li className="text-center py-4 text-muted">
//                     No episodes available
//                   </li>
//                 )}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* SHARE MODAL */}
//       {sharePopup.open && sharePopup.song && (
//         <div
//           className="modal-overlay"
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//           }}
//           onClick={() => setSharePopup({ open: false, song: null })}
//         >
//           <div
//             className="share-popup"
//             style={{
//               backgroundColor: "#1a1a1a",
//               padding: "25px",
//               borderRadius: "12px",
//               width: "90%",
//               maxWidth: "350px",
//               color: "white",
//               border: "1px solid #333",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ textAlign: "center", marginBottom: "25px" }}>
//               <h4
//                 style={{
//                   margin: "0 0 10px 0",
//                   fontSize: "18px",
//                   fontWeight: "600",
//                   color: "#ccc",
//                 }}
//               >
//                 Share
//               </h4>
//               <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>
//                 {sharePopup.song.title}
//               </p>
//             </div>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "20px",
//                 marginBottom: "25px",
//                 flexWrap: "wrap",
//               }}
//             >
//               {["facebook", "twitter", "whatsapp", "telegram"].map((p) => (
//                 <button
//                   key={p}
//                   onClick={() => shareOnSocialMedia(p, sharePopup.song)}
//                   style={{
//                     background: "none",
//                     border: "none",
//                     cursor: "pointer",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: "8px",
//                     fontSize: "12px",
//                     color: "#ccc",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "50px",
//                       height: "50px",
//                       backgroundColor:
//                         p === "facebook"
//                           ? "#1877f2"
//                           : p === "twitter"
//                           ? "#000000"
//                           : p === "whatsapp"
//                           ? "#25d366"
//                           : "#0088cc",
//                       borderRadius: "50%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <i
//                       className={`fab fa-${
//                         p === "twitter" ? "x-twitter" : p === "telegram" ? "telegram-plane" : p
//                       }`}
//                       style={{ color: "white", fontSize: "20px" }}
//                     ></i>
//                   </div>
//                   {p.charAt(0).toUpperCase() + p.slice(1)}
//                 </button>
//               ))}
//             </div>
//             <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
//               <input
//                 type="text"
//                 value={generateShareableUrl(sharePopup.song._id)}
//                 readOnly
//                 style={{
//                   flex: 1,
//                   padding: "12px 15px",
//                   backgroundColor: "#2a2a2a",
//                   border: "1px solid #444",
//                   borderRadius: "8px",
//                   color: "white",
//                   fontSize: "14px",
//                 }}
//               />
//               <button
//                 onClick={copyLink}
//                 style={{
//                   padding: "12px 20px",
//                   backgroundColor: "#1DB954",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "8px",
//                   cursor: "pointer",
//                   fontWeight: "600",
//                 }}
//               >
//                 COPY
//               </button>
//             </div>
//             <button
//               onClick={() => setSharePopup({ open: false, song: null })}
//               style={{
//                 width: "100%",
//                 padding: "12px",
//                 backgroundColor: "transparent",
//                 color: "#ccc",
//                 border: "1px solid #444",
//                 borderRadius: "8px",
//                 cursor: "pointer",
//               }}
//             >
//               CANCEL
//             </button>
//           </div>
//         </div>
//       )}

//       {/* PLAYLIST MODAL */}
//       {playlistModal.open && playlistModal.song && (
//         <div
//           className="modal-overlay"
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.8)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 9999,
//           }}
//           onClick={() => setPlaylistModal({ open: false, song: null })}
//         >
//           <div
//             className="playlist-popup"
//             style={{
//               backgroundColor: "#1a1a1a",
//               padding: "25px",
//               borderRadius: "12px",
//               width: "90%",
//               maxWidth: "400px",
//               color: "white",
//               border: "1px solid #333",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div style={{ textAlign: "center", marginBottom: "20px" }}>
//               <h4
//                 style={{
//                   margin: "0 0 12px 0",
//                   fontSize: "20px",
//                   fontWeight: "600",
//                 }}
//               >
//                 Add to Playlist
//               </h4>
//               <p style={{ margin: 0, color: "#ccc", fontSize: "16px" }}>
//                 {playlistModal.song.title}
//               </p>
//             </div>

//             {!showCreateForm ? (
//               <>
//                 <div
//                   style={{
//                     maxHeight: "250px",
//                     overflowY: "auto",
//                     marginBottom: "25px",
//                   }}
//                 >
//                   {playlists.length > 0 ? (
//                     playlists.map((p) => {
//                       const checked = selectedPlaylists.has(p._id);
//                       return (
//                         <label
//                           key={p._id}
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             padding: "16px",
//                             border: "1px solid #333",
//                             borderRadius: "14px",
//                             marginBottom: "12px",
//                             cursor: "pointer",
//                             backgroundColor: checked ? "#1DB95425" : "#222",
//                             transition: "all 0.2s",
//                           }}
//                           onClick={() => togglePlaylistSelection(p._id)}
//                         >
//                           <input
//                             type="checkbox"
//                             checked={checked}
//                             onChange={() => {}}
//                             style={{
//                               marginRight: "16px",
//                               transform: "scale(1.3)",
//                             }}
//                           />
//                           <img
//                             src={p.playlistCoverUrl || "img/covers/cover.svg"}
//                             alt={p.name}
//                             style={{
//                               width: "50px",
//                               height: "50px",
//                               borderRadius: "10px",
//                               marginRight: "16px",
//                               objectFit: "cover",
//                             }}
//                           />
//                           <div style={{ flex: 1 }}>
//                             <div style={{ fontWeight: "600", fontSize: "16px" }}>
//                               {p.name}
//                             </div>
//                             {p.description && (
//                               <small style={{ color: "#aaa" }}>
//                                 {p.description}
//                               </small>
//                             )}
//                           </div>
//                           {checked && (
//                             <i
//                               className="fas fa-check text-success ms-2"
//                               style={{ fontSize: "20px" }}
//                             ></i>
//                           )}
//                         </label>
//                       );
//                     })
//                   ) : (
//                     <div
//                       style={{
//                         textAlign: "center",
//                         padding: "40px",
//                         color: "#888",
//                       }}
//                     >
//                       No playlists yet
//                     </div>
//                   )}
//                 </div>

//                 <div className="d-flex gap-3">
//                   <button
//                     onClick={addToSelectedPlaylists}
//                     disabled={selectedPlaylists.size === 0 || playlistLoading}
//                     style={{
//                       flex: 1,
//                       padding: "16px",
//                       backgroundColor: "#1DB954",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "14px",
//                       cursor:
//                         selectedPlaylists.size === 0 ? "not-allowed" : "pointer",
//                       fontWeight: "700",
//                       opacity: selectedPlaylists.size === 0 ? 0.5 : 1,
//                     }}
//                   >
//                     {playlistLoading
//                       ? "Adding..."
//                       : `Add to ${selectedPlaylists.size} Playlist${
//                           selectedPlaylists.size > 1 ? "s" : ""
//                         }`}
//                   </button>
//                   <button
//                     onClick={() => setShowCreateForm(true)}
//                     style={{
//                       flex: 1,
//                       padding: "16px",
//                       backgroundColor: "transparent",
//                       color: "#ccc",
//                       border: "1px solid #555",
//                       borderRadius: "14px",
//                       cursor: "pointer",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Create New
//                   </button>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <input
//                   className="form-control mb-3"
//                   placeholder="Playlist Name *"
//                   value={newPlaylist.name}
//                   onChange={(e) =>
//                     setNewPlaylist((prev) => ({ ...prev, name: e.target.value }))
//                   }
//                   style={{
//                     backgroundColor: "#2a2a2a",
//                     border: "1px solid #444",
//                     color: "white",
//                     padding: "16px",
//                     borderRadius: "12px",
//                   }}
//                 />
//                 <textarea
//                   className="form-control mb-3"
//                   placeholder="Description (optional)"
//                   rows="3"
//                   value={newPlaylist.description}
//                   onChange={(e) =>
//                     setNewPlaylist((prev) => ({
//                       ...prev,
//                       description: e.target.value,
//                     }))
//                   }
//                   style={{
//                     backgroundColor: "#2a2a2a",
//                     border: "1px solid #444",
//                     color: "white",
//                     padding: "16px",
//                     borderRadius: "12px",
//                     resize: "none",
//                   }}
//                 />
//                 <input
//                   type="file"
//                   accept="image/*"
//                   className="form-control mb-4"
//                   onChange={handleFileChange}
//                   style={{
//                     backgroundColor: "#2a2a2a",
//                     border: "1px solid #444",
//                     color: "white",
//                     padding: "12px",
//                   }}
//                 />

//                 <div className="d-flex gap-3">
//                   <button
//                     onClick={createNewPlaylist}
//                     disabled={playlistLoading}
//                     style={{
//                       flex: 1,
//                       padding: "16px",
//                       backgroundColor: "#1DB954",
//                       color: "white",
//                       border: "none",
//                       borderRadius: "14px",
//                       cursor: "pointer",
//                       fontWeight: "700",
//                     }}
//                   >
//                     {playlistLoading ? "Creating..." : "Create & Add"}
//                   </button>
//                   <button
//                     onClick={() => setShowCreateForm(false)}
//                     style={{
//                       flex: 1,
//                       padding: "16px",
//                       backgroundColor: "transparent",
//                       color: "#ccc",
//                       border: "1px solid #555",
//                       borderRadius: "14px",
//                       cursor: "pointer",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Cancel
//                   </button>
//                 </div>
//               </>
//             )}

//             <button
//               onClick={() => setPlaylistModal({ open: false, song: null })}
//               style={{
//                 width: "100%",
//                 marginTop: "20px",
//                 padding: "16px",
//                 backgroundColor: "transparent",
//                 color: "#ccc",
//                 border: "1px solid #555",
//                 borderRadius: "14px",
//                 cursor: "pointer",
//                 fontSize: "16px",
//               }}
//             >
//               CLOSE
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PodcastEpisode;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext";

function PodcastEpisode() {
  const { id, source } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [podcastInfo, setPodcastInfo] = useState(null);
  const videoRef = useRef(null);

  const [sharePopup, setSharePopup] = useState({ open: false, song: null });
  const [playlistModal, setPlaylistModal] = useState({
    open: false,
    song: null,
  });
  const [playlists, setPlaylists] = useState([]);
  const [newPlaylist, setNewPlaylist] = useState({
    name: "",
    description: "",
    coverImage: null,
  });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [playlistLoading, setPlaylistLoading] = useState(false);
  const [selectedPlaylists, setSelectedPlaylists] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    description: "",
    coverImage: "",
  });
  console.log("error playl;ist", errors);
  const {
    isPlaying,
    currentTrack,
    togglePlayPause,
    seek,
    duration,
    triggerQueueUpdate,
    playTrackById,
    stopPlayback,
    videoRef: playerVideoRef,
  } = usePlayer();

  const [selectedEpisodeId, setSelectedEpisodeId] = useState(null);
  const [hasInitiatedPlayback, setHasInitiatedPlayback] = useState(false);

  useEffect(() => {
    setSelectedEpisodeId(null);
    setHasInitiatedPlayback(false);
    setEpisodes([]);
    setLoading(true);
    setError(null);
  }, [id]);

  useEffect(() => {
    if (!selectedEpisodeId && episodes.length > 0) {
      setSelectedEpisodeId(episodes[0]._id);
    }
  }, [episodes, selectedEpisodeId]);

  const selectedEpisode =
    episodes.find((episode) => episode._id === selectedEpisodeId) || null;

  const displayTrack =
    selectedEpisode || (episodes.length > 0 ? episodes[0] : null);

  const isDisplayTrackPlaying =
    hasInitiatedPlayback &&
    isPlaying &&
    currentTrack?._id &&
    currentTrack?._id === displayTrack?._id;

  // Lock background scroll when playlist modal is open
  useEffect(() => {
    if (!playlistModal.open) return;

    const scrollY = window.scrollY || 0;
    const body = document.body;
    const prevOverflow = body.style.overflow;
    const prevPosition = body.style.position;
    const prevTop = body.style.top;
    const prevWidth = body.style.width;

    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";

    return () => {
      body.style.overflow = prevOverflow;
      body.style.position = prevPosition;
      body.style.top = prevTop;
      body.style.width = prevWidth;
      window.scrollTo(0, scrollY);
    };
  }, [playlistModal.open]);

  // === UTILS ===
  const formatDuration = useCallback((seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }, []);

  const generateShareableUrl = (episodeId) =>
    `${process.env.REACT_APP_FRONTEND_URL || window.location.origin}podcast-episode/${id}/episode/${episodeId}`;

  // `https://webmobrildemo.com/volumetv/podcast-episode/${id}/episode/${episodeId}`;
  // console.log("loc", location.state?.trackData);
  // === FETCH DATA ===
  const fetchPodcastEpisodes = useCallback(async () => {
    // For tracks, skip API call and use track data from navigation state
    if (location.state?.source === "track" && location.state?.trackData) {
      const trackData = location.state.trackData;
      const formattedTrack = {
        ...trackData,
        isVideo:
          trackData.fileType === "video" ||
          trackData.mimeType?.includes("video") ||
          trackData.fileUrl?.includes(".mp4"),
      };
      setEpisodes([formattedTrack]);
      setPodcastInfo({
        _id: trackData._id,
        title: trackData.title,
        coverImageUrl: trackData.coverImageUrl,
      });
      setLoading(false);
      return;
    }

    // For tracks without state data (refresh / shared URL), fetch single track
    if (source === "track") {
      try {
        setLoading(true);
        const res = await httpClient.get(`/user/music/media-track/${id}`);
        if (res.data?.success) {
          const data = res.data.data;
          const formattedTrack = {
            ...data,
            isVideo:
              data.fileType === "video" ||
              data.mimeType?.includes("video") ||
              data.fileUrl?.includes(".mp4"),
          };
          setEpisodes([formattedTrack]);
          setPodcastInfo({
            _id: data._id,
            title: data.title,
            coverImageUrl: data.coverImageUrl,
          });
        }
      } catch (err) {
        setError("Failed to load track");
      } finally {
        setLoading(false);
      }
      return;
    }

    // For other sources, fetch from API
    try {
      setLoading(true);
      const res = await httpClient.get(
        `user/podcast/podcast-episodes/${id}?pageSize=50&pageNumber=1`,
      );
      if (res.data?.success) {
        const data = res.data.data.popularData || [];
        const formatted = data.map((ep) => ({
          ...ep,
          isVideo:
            ep.fileType === "video" ||
            ep.mimeType?.includes("video") ||
            ep.fileUrl?.includes(".mp4"),
        }));
        setEpisodes(formatted);
        setPodcastInfo(data[0]?.parentId || {});
      }
    } catch (err) {
      setError("Failed to load podcast");
    } finally {
      setLoading(false);
    }
  }, [id, source, location.state?.source, location.state?.trackData]);

  // Play count is recorded only by PlayerContext (single source of truth)

  // === PLAY EPISODE ===
  const playEpisode = async (episode) => {
    if (!episode?._id) return;
    const contentId = episode._id;

    setSelectedEpisodeId(contentId);
    setHasInitiatedPlayback(true);

    if (currentTrack?._id === contentId) {
      if (!isPlaying) await togglePlayPause();
      return;
    }

    if (typeof stopPlayback === "function") {
      stopPlayback();
    }

    try {
      const mediaType = episode?.isVideo ? "video" : "audio";
      await playTrackById(contentId, mediaType);
    } catch (error) {
      console.error("Error playing episode:", error);
    }
  };

  const handleTopPlayPauseClick = async () => {
    if (!displayTrack) return;
    setHasInitiatedPlayback(true);
    if (currentTrack?._id !== displayTrack._id) {
      await playEpisode(displayTrack);
      return;
    }
    await togglePlayPause();
  };

  // === LIKE/DISLIKE === (optimistic update so UI reflects immediately)
  const handleLikeDislike = async (contentId, currentAction) => {
    const newAction = currentAction === "like" ? "dislike" : "like";
    const isLiking = newAction === "like";

    // Optimistic update: reflect immediately in UI
    setEpisodes((prev) =>
      prev.map((ep) =>
        ep._id === contentId
          ? {
              ...ep,
              isLike: isLiking,
              likesCount: isLiking
                ? (ep.likesCount || 0) + 1
                : Math.max(0, (ep.likesCount || 0) - 1),
            }
          : ep,
      ),
    );

    try {
      const res = await httpClient.post(
        `/user/play-history/like-content/${contentId}/${newAction}`,
        {},
        {
          skipToast: true,
          skipLoader: true,
        },
      );
      if (!res.data?.success) {
        // Revert on API failure
        setEpisodes((prev) =>
          prev.map((ep) =>
            ep._id === contentId
              ? {
                  ...ep,
                  isLike: !isLiking,
                  likesCount: isLiking
                    ? Math.max(0, (ep.likesCount || 0) - 1)
                    : (ep.likesCount || 0) + 1,
                }
              : ep,
          ),
        );
      }
    } catch (err) {
      console.error("Like error:", err);
      // Revert on error
      setEpisodes((prev) =>
        prev.map((ep) =>
          ep._id === contentId
            ? {
                ...ep,
                isLike: !isLiking,
                likesCount: isLiking
                  ? Math.max(0, (ep.likesCount || 0) - 1)
                  : (ep.likesCount || 0) + 1,
              }
            : ep,
        ),
      );
    }
  };

  // === QUEUE ACTION ===
  const handleQueueAction = async (action, trackId) => {
    try {
      const payload = { action };
      if (trackId) payload.trackId = trackId;
      const res = await httpClient.post(
        "user/queue/queue-controller",
        payload,
        { skipLoader: true, skipErrorToast: true },
      );
      if (res.data?.success) triggerQueueUpdate();
    } catch (err) {
      console.error("Queue error:", err);
    }
  };

  // === SHARE ===
  const shareOnSocialMedia = (platform, episode) => {
    const url = generateShareableUrl(episode._id);
    const text = `Check out: ${episode.title}`;
    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      whatsapp: `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    };
    window.open(links[platform], "_blank", "width=600,height=400");
  };

  const copyLink = async () => {
    const text = generateShareableUrl(sharePopup.song._id);
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied!");
    } catch (err) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Copied!");
    }
  };

  // === PLAYLIST MODAL ===
  const fetchPlaylists = useCallback(async () => {
    try {
      const res = await httpClient.get("/user/playlist/get-playlists");
      if (res.data?.success) setPlaylists(res.data.data.playlist || []);
    } catch (err) {
      console.error("Error fetching playlists:", err);
    }
  }, []);

  const openPlaylistModal = useCallback(
    (episode, e) => {
      e.preventDefault();
      e.stopPropagation();
      setPlaylistModal({ open: true, song: episode });
      setSelectedPlaylists(null);
      fetchPlaylists();
      setOpenDropdown(null);
    },
    [fetchPlaylists],
  );

  const togglePlaylistSelection = (playlistId) => {
    console.log("toggle playlist selection", playlistId);
    // setSelectedPlaylists((prev) => {
    //   const newSet = new Set(prev);
    //   newSet.has(playlistId)
    //     ? newSet.delete(playlistId)
    //     : newSet.add(playlistId);
    //   return newSet;
    // });
    setSelectedPlaylists(playlistId);
    return playlistId;
  };

  const addToSelectedPlaylists = async () => {
    if (!selectedPlaylists) return;
    setPlaylistLoading(true);
    try {
      // for (const pid of selectedPlaylists) {
      await httpClient.post(
        `/user/playlist/add-item?playlistId=${selectedPlaylists}&itemId=${playlistModal.song._id}&itemType=Music`,
      );
      // }
      setPlaylistModal({ open: false, song: null });
    } catch (err) {
      console.error("Error adding to playlists:", err);
    } finally {
      setPlaylistLoading(false);
    }
  };

  const validateField = (key, value) => {
    let message = "";

    switch (key) {
      case "name":
        if (!value.trim()) {
          message = "Playlist name is required";
        } else if (value.trim().length < 3) {
          message = "Name must be at least 3 characters";
        }
        break;

      case "description":
        if (!value || !value.trim()) {
          message = "Description is required";
        } else if (value && value.length > 200) {
          message = "Description cannot exceed 200 characters";
        }

        break;

      case "coverImage":
        if (!value) {
          message = "Cover image is required";
        } else if (value) {
          const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
          if (!allowedTypes.includes(value.type)) {
            message = "Only JPG, PNG or WEBP allowed";
          }
          // if (value.size > 2 * 1024 * 1024) {
          //   message = "Image must be less than 2MB";
          // }
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [key]: message,
    }));

    return !message; // true if valid
  };
  const createNewPlaylist = async () => {
    // if (!newPlaylist.name.trim()) return alert("Name required");
    const isNameValid = validateField("name", newPlaylist.name);
    // const isDescValid = validateField("description", newPlaylist.description);
    const isImageValid = validateField("coverImage", newPlaylist.coverImage);

    if (!isNameValid || !isImageValid) return;

    setPlaylistLoading(true);

    const formData = new FormData();
    formData.append("name", newPlaylist.name);
    formData.append("description", newPlaylist.description);
    if (newPlaylist.coverImage)
      formData.append("coverImage", newPlaylist.coverImage);

    try {
      const res = await httpClient.post(
        "/user/playlist/create-playlist",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res.data?.success) {
        await fetchPlaylists();
        if (playlistModal.song) {
          await httpClient.post(
            `/user/playlist/add-item?playlistId=${res.data.data.playlist._id}&itemId=${playlistModal.song._id}&itemType=Music`,
          );
        }
        setPlaylistModal({ open: false, song: null });
        setShowCreateForm(false);
        setNewPlaylist({ name: "", description: "", coverImage: null });
      }
    } catch (err) {
      // alert("Failed to create playlist");
    } finally {
      setPlaylistLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setNewPlaylist((prev) => ({ ...prev, coverImage: file }));
  };

  // === DROPDOWN TOGGLE ===
  const toggleDropdown = (episodeId, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdown((prev) => (prev === episodeId ? null : episodeId));
  };

  // === SYNC VIDEO REF & SRC WITH PLAYER CONTEXT ===
  useEffect(() => {
    if (videoRef.current && playerVideoRef && displayTrack?.isVideo) {
      playerVideoRef.current = videoRef.current;
      playerVideoRef.current.src = displayTrack.fileUrl;
      playerVideoRef.current.poster = displayTrack.coverImageUrl || "";
      playerVideoRef.current.playsInline = true;
    }
  }, [playerVideoRef, displayTrack]);

  // === LIFECYCLE ===
  useEffect(() => {
    if (id) fetchPodcastEpisodes();
  }, [id, fetchPodcastEpisodes]);

  // Play count is recorded only by PlayerContext (single source of truth)

  useEffect(() => {
    const handleOutside = (e) => {
      if (!e.target.closest(".dropdown")) setOpenDropdown(null);
      if (
        !e.target.closest(".share-popup") &&
        !e.target.closest(".single-item__export")
      )
        setSharePopup({ open: false, song: null });
      if (
        !e.target.closest(".playlist-popup") &&
        !e.target.closest(".dropdown-item")
      ) {
        setPlaylistModal({ open: false, song: null });
        setShowCreateForm(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  // === HELPERS ===
  const isCurrentPlaying = (id) => currentTrack?._id === id;

  // === RENDER ===
  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-inner pb-0 container-fluid">
        <div className="alert alert-danger text-center">{error}</div>
      </div>
    );
  }

  return (
    <div
      className="content-inner pb-0 container-fluid pro-episode-page"
      id="page_layout"
    >
      <style>
        {`
          @media (max-width: 575.98px) {
            .pro-episode-page .release__list {
              margin-top: 8rem !important;
            }
          }
        `}
      </style>
      <div className="row row--grid">
        <div className="col-12">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <Link to="/">Home</Link>
            </li>
            {(source === "podcast" || source === "genre-podcast") && (
              <li className="breadcrumb__item">
                <Link to="/podcasts">Podcasts</Link>
              </li>
            )}
            {source === "genre-podcast" && (
              <li className="breadcrumb__item">
                <Link to="/podcasts/genre-podcasts">Genre Podcasts</Link>
              </li>
            )}
            {source === "track" && (
              <li className="breadcrumb__item">
                <Link to="/trending">Trending</Link>
              </li>
            )}
            <li className="breadcrumb__item breadcrumb__item--active">
              {podcastInfo?.title ||
                displayTrack?.title ||
                (source === "track" ? "Song" : "Episode")}
            </li>
          </ul>
          <div className="main__title main__title--page">
            <h1>{podcastInfo?.title || "Podcast"}</h1>
            {displayTrack && (
              <span className="badge bg-primary ms-2">
                {displayTrack.isVideo ? "Video" : "Audio"}
              </span>
            )}
          </div>
        </div>

        <div className="col-12">
          <div className="release">
            <div className="release__content">
              <div className="release__cover">
                {displayTrack?.isVideo ? (
                  <div className="position-relative rounded overflow-hidden">
                    <video
                      ref={videoRef}
                      className="w-100 h-100"
                      style={{ objectFit: "contain" }}
                      src={displayTrack.fileUrl}
                      playsInline
                    />
                  </div>
                ) : (
                  <div className="position-relative">
                    <img
                      src={
                        displayTrack?.coverImageUrl ||
                        podcastInfo?.coverImageUrl ||
                        `${process.env.PUBLIC_URL}/img/covers/cover.svg`
                      }
                      alt={displayTrack?.title || "cover"}
                      className="img-fluid rounded"
                      style={{
                        maxHeight: "340px",
                        width: "100%",
                        height: "340px",
                        objectFit: "contain",
                        background: "#1a1a1a",
                      }}
                      onError={(e) => {
                        e.currentTarget.src = `${process.env.PUBLIC_URL}/img/covers/cover.svg`;
                      }}
                    />
                    {isDisplayTrackPlaying && (
                      <div className="position-absolute top-50 start-50 translate-middle">
                        <i
                          className="fas fa-volume-up fa-beat text-white"
                          style={{
                            fontSize: "60px",
                          }}
                        ></i>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="release__stat">
                <span>
                  {episodes.length}{" "}
                  {source === "podcast" || source === "genre-podcast"
                    ? "episodes"
                    : "song(s)"}
                </span>
                <span>
                  {episodes
                    .reduce((a, b) => a + (b.playCount || 0), 0)
                    .toLocaleString()}{" "}
                  listens
                </span>
              </div>
              <div className="d-flex justify-content-between gap-3 mt-3">
                <button
                  type="button"
                  className="release__buy open-modal"
                  onClick={handleTopPlayPauseClick}
                  disabled={!displayTrack}
                  style={{
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i
                    className={
                      isDisplayTrackPlaying ? "fas fa-pause" : "fas fa-play"
                    }
                  ></i>
                  {isDisplayTrackPlaying ? "PAUSE" : "PLAY"}
                </button>
              </div>
            </div>

            <div className="release__list mt-5">
              <h4 className="card-title text-white mb-4">
                All{" "}
                {source === "podcast" || source === "genre-podcast"
                  ? "Episodes"
                  : "Song(s)"}
              </h4>
              <ul className="main__list main__list--playlist main__list--dashbox ps-0">
                {episodes.length > 0 ? (
                  episodes.map((episode, i) => {
                    const contentId = episode._id;
                    const isCurrent = currentTrack?._id === contentId;
                    const playing = isCurrentPlaying(contentId);
                    const isDropdownOpen = openDropdown === contentId;
                    const artistId = episode.artistId || episode.artist?._id;
                    const albumId = episode.albumId || episode.album?._id;

                    return (
                      <li
                        key={contentId}
                        className={`single-item list-1 ${isCurrent ? "active-episode" : ""}`}
                        style={{
                          backgroundColor: playing
                            ? "rgba(255,255,255,0.1)"
                            : "",
                          borderLeft: playing
                            ? "3px solid #1DB954"
                            : "3px solid transparent",
                        }}
                      >
                        <div
                          className="single-item__cover ms-2"
                          onClick={() => playEpisode(episode)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={
                              episode.coverImageUrl ||
                              `${process.env.PUBLIC_URL}/img/covers/cover.svg`
                            }
                            alt={episode.title}
                          />
                          {playing && isPlaying ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{ fill: "#1DB954" }}
                            >
                              <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              style={{ fill: playing ? "#1DB954" : "#fff" }}
                            >
                              <path d="M18.54,9L8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
                            </svg>
                          )}
                        </div>

                        <div
                          className="single-item__title"
                          onClick={() => playEpisode(episode)}
                          style={{ cursor: "pointer" }}
                        >
                          <h4
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <span>
                                {i + 1}. {episode.title}
                              </span>
                              {episode.isVideo && (
                                <i className="fas fa-video text-primary"></i>
                              )}
                            </span>
                           
                          </h4>
                          <span>{episode.artist || "Unknown Artist"}</span>
                          {/* {playing && (
                              <span
                                className="badge ms-0"
                                style={{
                                  backgroundColor: "#1db954",
                                  color: "#fff",
                                  fontSize: "0.7em",
                                  lineHeight: 1.2,
                                  padding: "4px 8px",
                                  borderRadius: "999px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                Playing
                              </span>
                            )} */}
                        </div>

                        {/* Dropdown */}
                        <div className="dropdown">
                          <span
                            className={`d-flex text-white align-items-center h5 mb-0 ${isDropdownOpen ? "show" : ""}`}
                            onClick={(e) => toggleDropdown(contentId, e)}
                          >
                            <i className="fas fa-ellipsis-h"></i>
                          </span>
                          <div
                            className={`dropdown-menu dropdown-menu-end ${isDropdownOpen ? "show" : ""}`}
                            style={
                              isDropdownOpen
                                ? {
                                    position: "absolute",
                                    inset: "0px 0px auto auto",
                                    margin: "0px",
                                    transform: "translate(0px, 19px)",
                                  }
                                : {}
                            }
                          >
                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => openPlaylistModal(episode, e)}
                            >
                              <span className="material-icons">
                                library_music
                              </span>{" "}
                              Add To Playlist
                            </a>

                            <a
                              className="dropdown-item"
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                handleQueueAction("add", contentId);
                                setOpenDropdown(null);
                              }}
                            >
                              <span className="material-icons">
                                playlist_add
                              </span>{" "}
                              Add To Queue
                            </a>

                            <a
                              className={`dropdown-item ${!artistId ? "disabled" : ""}`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (artistId) {
                                  navigate(`/artist/${artistId}`);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">music_note</span>{" "}
                              Go To Artist
                            </a>

                            <a
                              className={`dropdown-item ${!albumId ? "disabled" : ""}`}
                              href="#!"
                              onClick={(e) => {
                                e.preventDefault();
                                if (albumId) {
                                  navigate(`/album/${albumId}`);
                                  setOpenDropdown(null);
                                }
                              }}
                            >
                              <span className="material-icons">album</span> Go
                              To Album
                            </a>
                          </div>
                        </div>

                        <a
                          href="#!"
                          className={`single-item__add ${episode.isLike ? "liked" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleLikeDislike(
                              contentId,
                              episode.isLike ? "like" : "dislike",
                            );
                          }}
                        >
                          <i
                            className={
                              episode.isLike
                                ? "fas fa-heart text-danger"
                                : "far fa-heart"
                            }
                          ></i>
                        </a>

                        <a
                          href="#!"
                          className="single-item__export"
                          onClick={(e) => {
                            e.preventDefault();
                            setSharePopup({ open: true, song: episode });
                          }}
                        >
                          <i className="fas fa-share"></i>
                        </a>

                        {/* <span className="single-item__time">
                          {isCurrent
                            ? `${formatDuration(seek)} / ${formatDuration(duration)}`
                            : formatDuration(episode.duration)}
                        </span> */}
                      </li>
                    );
                  })
                ) : (
                  <li
                    className="text-center py-5"
                    style={{ listStyle: "none" }}
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                        alt="No content"
                        style={{
                          width: "120px",
                          height: "120px",
                          opacity: 0.4,
                          marginBottom: "20px",
                        }}
                        onError={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      />
                      <h5 className="text-white mb-2">
                        {source === "podcast" || source === "genre-podcast"
                          ? "No episodes available"
                          : "No songs available"}
                      </h5>
                      <p className="text-muted mb-0">
                        {source === "podcast" || source === "genre-podcast"
                          ? "There are no episodes for this podcast yet. Please check back later."
                          : "No songs were found for this selection."}
                      </p>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* SHARE MODAL */}
      {sharePopup.open && sharePopup.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setSharePopup({ open: false, song: null })}
        >
          <div
            className="share-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "350px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "25px" }}>
              <h4
                style={{
                  margin: "0 0 10px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#aaa7a7",
                }}
              >
                Share
              </h4>
              <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>
                {sharePopup.song.title}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "25px",
                flexWrap: "wrap",
              }}
            >
              {["facebook", "twitter", "whatsapp", "telegram"].map((p) => (
                <button
                  key={p}
                  onClick={() => shareOnSocialMedia(p, sharePopup.song)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "12px",
                    color: "#ccc",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor:
                        p === "facebook"
                          ? "#1877f2"
                          : p === "twitter"
                            ? "#000000"
                            : p === "whatsapp"
                              ? "#25d366"
                              : "#0088cc",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={`fab fa-${
                        p === "twitter"
                          ? "x-twitter"
                          : p === "telegram"
                            ? "telegram-plane"
                            : p
                      }`}
                      style={{ color: "white", fontSize: "20px" }}
                    ></i>
                  </div>
                  {p.charAt(0).toUpperCase() + p.slice(1)}
                </button>
              ))}
            </div>
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
              <input
                type="text"
                value={generateShareableUrl(sharePopup.song._id)}
                readOnly
                style={{
                  flex: 1,
                  padding: "12px 15px",
                  backgroundColor: "#2a2a2a",
                  border: "1px solid #444",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "14px",
                }}
              />
              <button
                onClick={copyLink}
                style={{
                  padding: "12px 20px",
                  backgroundColor: "#1DB954",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                COPY
              </button>
            </div>
            <button
              onClick={() => setSharePopup({ open: false, song: null })}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "transparent",
                color: "#ccc",
                border: "1px solid #444",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      )}

      {/* PLAYLIST MODAL */}
      {playlistModal.open && playlistModal.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setPlaylistModal({ open: false, song: null })}
        >
          <div
            className="playlist-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "400px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h4
                style={{
                  margin: "0 0 12px 0",
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "white",
                }}
              >
                Add to Playlist
              </h4>
              <p style={{ margin: 0, color: "#ccc", fontSize: "16px" }}>
                {playlistModal.song.title}
              </p>
            </div>

            {!showCreateForm ? (
              <>
                <div
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    marginBottom: "25px",
                    scrollbarWidth: "none",
                  }}
                >
                  {playlists.length > 0 ? (
                    playlists.map((p) => {
                      const checked = selectedPlaylists === p?._id;
                      return (
                        <label
                          key={p._id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "16px",
                            border: "1px solid #333",
                            borderRadius: "14px",
                            marginBottom: "12px",
                            cursor: "pointer",
                            backgroundColor: checked ? "#1DB95425" : "#222",
                            transition: "all 0.2s",
                          }}
                          onClick={() => togglePlaylistSelection(p._id)}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => {}}
                            style={{
                              marginRight: "16px",
                              transform: "scale(1.3)",
                            }}
                          />
                          <img
                            src={
                              p?.playlistCoverUrl || "/img/live/songDefault.png"
                            }
                            alt={p.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "10px",
                              marginRight: "16px",
                              objectFit: "cover",
                            }}
                          />
                          <div style={{ flex: 1 }}>
                            <div
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {p.name}
                            </div>
                            {p.description && (
                              <small style={{ color: "#aaa" }}>
                                {p.description}
                              </small>
                            )}
                          </div>
                          {checked && (
                            <i
                              className="fas fa-check text-success ms-2"
                              style={{ fontSize: "20px" }}
                            ></i>
                          )}
                        </label>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#888",
                      }}
                    >
                      No playlists yet
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3">
                  <button
                    onClick={addToSelectedPlaylists}
                    disabled={playlistLoading}
                    style={{
                      flex: 1,
                      padding: "16px",
                      backgroundColor: "#1DB954",
                      color: "white",
                      border: "none",
                      borderRadius: "14px",
                      cursor: !selectedPlaylists ? "not-allowed" : "pointer",
                      fontWeight: "700",
                      opacity: selectedPlaylists ? 1 : 0.5,
                    }}
                  >
                    {playlistLoading ? "Adding..." : `Add to Playlist`}
                  </button>
                  <button
                    onClick={() => setShowCreateForm(true)}
                    style={{
                      flex: 1,
                      padding: "16px",
                      backgroundColor: "transparent",
                      color: "#ccc",
                      border: "1px solid #555",
                      borderRadius: "14px",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Create New
                  </button>
                </div>
              </>
            ) : (
              <>
                <input
                  className="form-control mb-3"
                  placeholder="Playlist Name *"
                  value={newPlaylist.name}
                  onChange={(e) =>
                    setNewPlaylist((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                  style={{
                    backgroundColor: "#2a2a2a",
                    border: "1px solid #444",
                    color: "white",
                    padding: "16px",
                    borderRadius: "12px",
                  }}
                />
                {errors.name && (
                  <small
                    style={{
                      color: "red",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    {errors.name}
                  </small>
                )}
                <textarea
                  className="form-control mb-3"
                  placeholder="Description (optional)"
                  rows="3"
                  value={newPlaylist.description}
                  onChange={(e) =>
                    setNewPlaylist((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  style={{
                    backgroundColor: "#2a2a2a",
                    border: "1px solid #444",
                    color: "white",
                    padding: "16px",
                    borderRadius: "12px",
                    resize: "none",
                  }}
                />
                {errors.description && (
                  <small
                    style={{
                      color: "red",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    {errors.description}
                  </small>
                )}
                <input
                  type="file"
                  accept="image/*"
                  className="form-control mb-4"
                  onChange={handleFileChange}
                  style={{
                    backgroundColor: "#2a2a2a",
                    border: "1px solid #444",
                    color: "white",
                    padding: "12px",
                  }}
                />
                {errors.coverImage && (
                  <small
                    style={{
                      color: "red",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    {errors.coverImage}
                  </small>
                )}
                <div className="d-flex gap-3">
                  <button
                    onClick={createNewPlaylist}
                    disabled={playlistLoading}
                    style={{
                      flex: 1,
                      padding: "16px",
                      backgroundColor: "#1DB954",
                      color: "white",
                      border: "none",
                      borderRadius: "14px",
                      cursor: "pointer",
                      fontWeight: "700",
                    }}
                  >
                    {playlistLoading ? "Creating..." : "Create & Add"}
                  </button>
                  <button
                    onClick={() => setShowCreateForm(false)}
                    style={{
                      flex: 1,
                      padding: "16px",
                      backgroundColor: "transparent",
                      color: "#ccc",
                      border: "1px solid #555",
                      borderRadius: "14px",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </>
            )}

            <button
              onClick={() => setPlaylistModal({ open: false, song: null })}
              style={{
                width: "100%",
                marginTop: "20px",
                padding: "16px",
                backgroundColor: "transparent",
                color: "#ccc",
                border: "1px solid #555",
                borderRadius: "14px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              CLOSE
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default PodcastEpisode;
